function clickFiltersSubmit() {
  var submit = document.getElementById('filters-submit-js');
  if (submit) submit.click();
}

function normalizedFilterText(value) {
  return value.toString().toLowerCase().replace(/[^a-z0-9]/g, '');
}

document.addEventListener('keyup', function(event) {
  var searchInput = event.target.closest('.filter-search-js');
  if (!searchInput) return;

  var form = searchInput.closest('.filter-container-js');
  if (!form) return;

  var query = normalizedFilterText(searchInput.value);
  var filterValues = form.querySelectorAll('input.filter-value-js');

  filterValues.forEach(function(filterValue) {
    var filterContainer = filterValue.closest('.filter-value-container-js');
    if (!filterContainer) return;

    if (normalizedFilterText(filterValue.dataset.label).includes(query)) {
      filterContainer.classList.remove('d-none');
    } else {
      filterContainer.classList.add('d-none');
    }
  });

  var visibleFilters = form.querySelectorAll('.filter-value-container-js:not(.d-none)');
  var noResults = form.querySelector('.no-results-js');
  if (noResults) noResults.classList.toggle('d-none', visibleFilters.length !== 0);

  var optionsList = form.querySelector('.filter-items-list-js');
  var seeAllContainer = form.querySelector('.filter-see-all-container-js');
  if (!optionsList || !seeAllContainer) return;

  seeAllContainer.classList.toggle(
    'd-none',
    !(visibleFilters.length > 10 && optionsList.classList.contains('not-scrollable'))
  );
});

document.addEventListener('click', function(event) {
  var seeAllButton = event.target.closest('.filter-see-all-btn-js');
  if (!seeAllButton) return;

  var seeAllContainer = seeAllButton.closest('.filter-see-all-container-js');
  if (!seeAllContainer) return;
  var optionsList = seeAllContainer.parentElement && seeAllContainer.parentElement.querySelector('.filter-items-list-js');
  if (!optionsList) return;

  optionsList.classList.remove('not-scrollable');
  optionsList.classList.add('scrollable');
  seeAllContainer.classList.add('d-none');
});

// Needed only for updating applied filters in-place before the form reloads.
function addAppliedFilter(name, value, label) {
  var button = document.createElement('button');
  button.className = 'applied-filter-btn-js btn btn-sm btn-primary';
  button.dataset.name = name;
  button.dataset.value = value;
  button.innerHTML = label + '<i class="fas fa-fw fa-times" aria-hidden="true"></i>';

  document.querySelectorAll('.applied-filters-js').forEach(function(appliedFilters) {
    appliedFilters.appendChild(button.cloneNode(true));
  });
}

function removeAppliedFilter(name, value) {
  document.querySelectorAll('.applied-filters-js [data-name][data-value]').forEach(function(button) {
    if (button.dataset.name === name && button.dataset.value === value) button.remove();
  });
}

document.addEventListener('click', function(event) {
  var filterValue = event.target.closest('.filter-value-js');
  if (!filterValue) return;

  // Add/remove applied filters before page reloading while clicking on checkbox.
  if (filterValue.checked) {
    addAppliedFilter(filterValue.name.replace('[]', ''), filterValue.value, filterValue.labels[0].textContent);
  } else {
    removeAppliedFilter(filterValue.name.replace('[]', ''), filterValue.value);
  }

  clickFiltersSubmit();
});

function uncheckOption(name, value) {
  var input = Array.from(document.querySelectorAll('.filter-value-js')).find(function(filterValue) {
    return filterValue.name === name + '[]' && filterValue.value === value;
  });
  if (input) input.checked = false;
}

document.addEventListener('click', function(event) {
  var appliedFilterButton = event.target.closest('.applied-filter-btn-js');
  if (!appliedFilterButton) return;

  uncheckOption(appliedFilterButton.dataset.name, appliedFilterButton.dataset.value);
  clickFiltersSubmit();
});

document.addEventListener('click', function(event) {
  if (!event.target.closest('#filters-clear-all')) return;

  document.querySelectorAll('.applied-filter-btn-js').forEach(function(appliedFilter) {
    uncheckOption(appliedFilter.dataset.name, appliedFilter.dataset.value);
  });

  clickFiltersSubmit();
});
